import { styled, Box as MuiBox, Typography as MuiTypography } from "@mui/material";

export const Wrapper = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      padding: 40px 16px;
      max-width: auto;
      display: flex;
      flex-direction: column;

      ${breakpoints.up("md")} {
        max-width: 60vw;
      }
    }
  `
);

export const TableWrapper = styled(MuiBox)(
  () => `
    &.MuiBox-root {
      display: flex;
      flex-direction: column;
      box-shadow: 0px 1px 3px 0px #0000001F;

      & > .MuiDataGrid-root {
        border-radius: 0;
      }
    }
  `
);

export const Title = styled(MuiTypography)(
  ({
    theme: {
      palette: { custom },
      typography: { body2 }
    }
  }) => `
    &.MuiTypography-root {
      font-size: ${body2.mobile.fontSize};
      line-height: ${body2.mobile.lineHeight};
      font-weight: 500;
      color: ${custom.white.main};
      padding: 16px 10px;
      background-color: ${custom.background};
    }
  `
);

export const SubmitButtonWrapper = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      & > .MuiButton-root {
        height: 31px;
      }

      ${breakpoints.up("md")} {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        & > .MuiButton-root {
          width: 240px;
        }
      }
    }
  `
);
